//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//       bebopc version:
//           3.2.3
//
//
//       bebopc source:
//           https://github.com/6over3/bebop
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
import { BebopView, BebopRuntimeError, BebopRecord } from "bebop";

export const BEBOP_SCHEMA = new Uint8Array ([
3, 23, 0, 0, 0, 79, 98, 106, 101, 99, 116, 84, 121, 112,
101, 0, 4, 0, 251, 255, 255, 255, 0, 4, 0, 0, 0, 2, 76,
111, 98, 98, 121, 0, 0, 0, 0, 0, 0, 71, 97, 109, 101, 0,
0, 1, 0, 0, 0, 71, 97, 109, 101, 82, 97, 116, 105, 110,
103, 68, 101, 108, 116, 97, 0, 1, 0, 0, 16, 0, 0, 0, 0, 4,
117, 115, 101, 114, 73, 68, 0, 245, 255, 255, 255, 0, 115,
99, 111, 114, 101, 0, 250, 255, 255, 255, 0, 111, 114,
105, 103, 105, 110, 97, 108, 82, 97, 116, 105, 110, 103,
0, 250, 255, 255, 255, 0, 110, 101, 119, 82, 97, 116, 105,
110, 103, 0, 250, 255, 255, 255, 0, 85, 115, 101, 114, 66,
111, 111, 108, 69, 110, 116, 114, 121, 0, 1, 0, 0, 5, 0,
0, 0, 0, 2, 117, 115, 101, 114, 73, 68, 0, 245, 255, 255,
255, 0, 118, 97, 108, 117, 101, 0, 255, 255, 255, 255, 0,
85, 115, 101, 114, 73, 110, 116, 54, 52, 69, 110, 116,
114, 121, 0, 1, 0, 0, 12, 0, 0, 0, 0, 2, 117, 115, 101,
114, 73, 68, 0, 245, 255, 255, 255, 0, 118, 97, 108, 117,
101, 0, 248, 255, 255, 255, 0, 66, 105, 100, 0, 1, 0, 0,
2, 0, 0, 0, 1, 2, 116, 114, 97, 100, 101, 82, 111, 119,
73, 110, 100, 101, 120, 0, 254, 255, 255, 255, 0, 109,
105, 108, 105, 116, 97, 114, 121, 0, 254, 255, 255, 255,
0, 85, 115, 101, 114, 66, 105, 100, 69, 110, 116, 114,
121, 0, 1, 0, 0, 6, 0, 0, 0, 0, 2, 117, 115, 101, 114, 73,
68, 0, 245, 255, 255, 255, 0, 98, 105, 100, 0, 4, 0, 0, 0,
0, 82, 101, 115, 111, 108, 117, 116, 105, 111, 110, 83,
101, 108, 101, 99, 116, 105, 111, 110, 0, 1, 0, 0, 4, 0,
0, 0, 0, 1, 99, 97, 114, 100, 73, 68, 84, 111, 71, 97,
105, 110, 0, 245, 255, 255, 255, 0, 85, 115, 101, 114, 82,
101, 115, 111, 108, 118, 101, 115, 69, 110, 116, 114, 121,
0, 1, 0, 0, 8, 0, 0, 0, 0, 2, 117, 115, 101, 114, 73, 68,
0, 245, 255, 255, 255, 0, 115, 101, 108, 101, 99, 116,
105, 111, 110, 0, 6, 0, 0, 0, 0, 71, 97, 109, 101, 85,
112, 100, 97, 116, 101, 77, 101, 115, 115, 97, 103, 101,
0, 2, 0, 5, 0, 0, 0, 15, 103, 97, 109, 101, 73, 68, 0,
245, 255, 255, 255, 0, 1, 116, 97, 114, 103, 101, 116, 83,
101, 113, 117, 101, 110, 99, 101, 73, 68, 0, 251, 255,
255, 255, 0, 2, 115, 101, 113, 117, 101, 110, 99, 101, 73,
68, 0, 251, 255, 255, 255, 0, 3, 110, 101, 119, 69, 118,
101, 110, 116, 115, 77, 115, 103, 112, 97, 99, 107, 0,
242, 255, 255, 255, 0, 254, 255, 255, 255, 0, 4, 103, 97,
109, 101, 83, 116, 97, 114, 116, 84, 105, 109, 101, 115,
116, 97, 109, 112, 0, 248, 255, 255, 255, 0, 5, 103, 97,
109, 101, 85, 112, 100, 97, 116, 101, 84, 105, 109, 101,
115, 116, 97, 109, 112, 0, 248, 255, 255, 255, 0, 6, 103,
97, 109, 101, 69, 110, 100, 84, 105, 109, 101, 115, 116,
97, 109, 112, 0, 248, 255, 255, 255, 0, 7, 104, 97, 115,
71, 97, 109, 101, 69, 110, 100, 84, 105, 109, 101, 115,
116, 97, 109, 112, 0, 255, 255, 255, 255, 0, 8, 114, 97,
116, 105, 110, 103, 68, 101, 108, 116, 97, 115, 0, 242,
255, 255, 255, 0, 1, 0, 0, 0, 0, 9, 114, 101, 97, 100,
121, 66, 121, 85, 115, 101, 114, 73, 68, 0, 242, 255, 255,
255, 0, 2, 0, 0, 0, 0, 10, 116, 111, 116, 97, 108, 84,
104, 105, 110, 107, 105, 110, 103, 77, 105, 108, 108, 105,
115, 66, 121, 80, 108, 97, 121, 101, 114, 73, 68, 0, 242,
255, 255, 255, 0, 3, 0, 0, 0, 0, 11, 112, 104, 97, 115,
101, 84, 104, 105, 110, 107, 105, 110, 103, 77, 105, 108,
108, 105, 115, 66, 121, 80, 108, 97, 121, 101, 114, 73,
68, 0, 242, 255, 255, 255, 0, 3, 0, 0, 0, 0, 12, 112, 104,
97, 115, 101, 83, 116, 97, 114, 116, 84, 105, 109, 101,
115, 116, 97, 109, 112, 0, 248, 255, 255, 255, 0, 13, 98,
105, 100, 115, 66, 121, 80, 108, 97, 121, 101, 114, 73,
68, 0, 242, 255, 255, 255, 0, 5, 0, 0, 0, 0, 14, 114, 101,
115, 111, 108, 118, 101, 115, 66, 121, 80, 108, 97, 121,
101, 114, 73, 68, 0, 242, 255, 255, 255, 0, 7, 0, 0, 0, 0,
15, 79, 98, 106, 101, 99, 116, 85, 112, 100, 97, 116, 101,
72, 101, 97, 100, 101, 114, 0, 1, 0, 0, 16, 0, 0, 0, 0, 4,
116, 111, 112, 105, 99, 0, 245, 255, 255, 255, 0, 111, 98,
106, 101, 99, 116, 84, 121, 112, 101, 0, 0, 0, 0, 0, 0,
111, 98, 106, 101, 99, 116, 73, 68, 0, 245, 255, 255, 255,
0, 115, 101, 113, 117, 101, 110, 99, 101, 73, 68, 0, 251,
255, 255, 255, 0, 79, 98, 106, 101, 99, 116, 85, 112, 100,
97, 116, 101, 77, 101, 115, 115, 97, 103, 101, 0, 2, 0, 5,
0, 0, 0, 2, 104, 101, 97, 100, 101, 114, 0, 9, 0, 0, 0, 0,
1, 100, 97, 116, 97, 0, 8, 0, 0, 0, 0, 2, 67, 104, 97,
116, 78, 111, 116, 105, 102, 105, 99, 97, 116, 105, 111,
110, 0, 2, 0, 5, 0, 0, 0, 3, 117, 115, 101, 114, 73, 68,
0, 245, 255, 255, 255, 0, 1, 114, 111, 111, 109, 0, 245,
255, 255, 255, 0, 2, 116, 101, 120, 116, 0, 245, 255, 255,
255, 0, 3, 76, 111, 98, 98, 121, 76, 105, 115, 116, 78,
111, 116, 105, 102, 105, 99, 97, 116, 105, 111, 110, 0, 2,
0, 5, 0, 0, 0, 1, 116, 111, 112, 105, 99, 0, 245, 255,
255, 255, 0, 1, 65, 117, 116, 104, 83, 117, 99, 99, 101,
115, 115, 0, 2, 0, 5, 0, 0, 0, 1, 117, 115, 101, 114, 73,
68, 0, 245, 255, 255, 255, 0, 1, 65, 117, 116, 104, 69,
114, 114, 111, 114, 0, 2, 0, 5, 0, 0, 0, 1, 101, 114, 114,
111, 114, 77, 101, 115, 115, 97, 103, 101, 0, 245, 255,
255, 255, 0, 1, 84, 111, 97, 115, 116, 78, 111, 116, 105,
102, 105, 99, 97, 116, 105, 111, 110, 0, 2, 0, 5, 0, 0, 0,
2, 105, 100, 0, 245, 255, 255, 255, 0, 1, 116, 101, 120,
116, 0, 245, 255, 255, 255, 0, 2, 83, 101, 114, 118, 101,
114, 77, 101, 115, 115, 97, 103, 101, 0, 3, 0, 10, 0, 0,
0, 6, 1, 10, 0, 0, 0, 2, 11, 0, 0, 0, 3, 12, 0, 0, 0, 4,
13, 0, 0, 0, 5, 14, 0, 0, 0, 6, 15, 0, 0, 0, 83, 117, 98,
115, 99, 114, 105, 98, 101, 0, 2, 0, 5, 0, 0, 0, 1, 116,
111, 112, 105, 99, 0, 245, 255, 255, 255, 0, 1, 85, 110,
115, 117, 98, 115, 99, 114, 105, 98, 101, 0, 2, 0, 5, 0,
0, 0, 1, 116, 111, 112, 105, 99, 0, 245, 255, 255, 255, 0,
1, 67, 104, 97, 116, 0, 2, 0, 5, 0, 0, 0, 2, 114, 111,
111, 109, 0, 245, 255, 255, 255, 0, 1, 116, 101, 120, 116,
0, 245, 255, 255, 255, 0, 2, 65, 117, 116, 104, 85, 115,
101, 114, 0, 2, 0, 5, 0, 0, 0, 1, 106, 119, 116, 0, 245,
255, 255, 255, 0, 1, 65, 117, 116, 104, 65, 110, 111, 110,
121, 109, 111, 117, 115, 0, 2, 0, 5, 0, 0, 0, 0, 67, 108,
105, 101, 110, 116, 77, 101, 115, 115, 97, 103, 101, 0, 3,
0, 10, 0, 0, 0, 5, 1, 17, 0, 0, 0, 2, 18, 0, 0, 0, 3, 19,
0, 0, 0, 4, 20, 0, 0, 0, 5, 21, 0, 0, 0, 0, 0, 0, 0
]);

export enum ObjectType {

  Lobby = 0,

  Game = 1,
}


export interface GameRatingDelta {

  readonly userID: string;

  readonly score: number;

  readonly originalRating: number;

  readonly newRating: number;
}

export const GameRatingDelta = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: GameRatingDelta): GameRatingDelta & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return GameRatingDelta.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: GameRatingDelta): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      GameRatingDelta.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: GameRatingDelta, view: BebopView): void {
      view.writeString(record.userID);
      view.writeInt32(record.score);
      view.writeInt32(record.originalRating);
      view.writeInt32(record.newRating);
    },

    decode(buffer: Uint8Array): GameRatingDelta & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = GameRatingDelta.readFrom(view);
      return GameRatingDelta(decoded);
    },

    readFrom(view: BebopView): GameRatingDelta {
      let field0: string;
      field0 = view.readString();
      let field1: number;
      field1 = view.readInt32();
      let field2: number;
      field2 = view.readInt32();
      let field3: number;
      field3 = view.readInt32();
      return {
        userID: field0,
        score: field1,
        originalRating: field2,
        newRating: field3,
      };
    },
  }
));


export interface UserBoolEntry {

  readonly userID: string;

  readonly value: boolean;
}

export const UserBoolEntry = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: UserBoolEntry): UserBoolEntry & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return UserBoolEntry.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: UserBoolEntry): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      UserBoolEntry.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: UserBoolEntry, view: BebopView): void {
      view.writeString(record.userID);
      view.writeByte(Number(record.value));
    },

    decode(buffer: Uint8Array): UserBoolEntry & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = UserBoolEntry.readFrom(view);
      return UserBoolEntry(decoded);
    },

    readFrom(view: BebopView): UserBoolEntry {
      let field0: string;
      field0 = view.readString();
      let field1: boolean;
      field1 = !!view.readByte();
      return {
        userID: field0,
        value: field1,
      };
    },
  }
));


export interface UserInt64Entry {

  readonly userID: string;

  readonly value: bigint;
}

export const UserInt64Entry = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: UserInt64Entry): UserInt64Entry & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return UserInt64Entry.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: UserInt64Entry): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      UserInt64Entry.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: UserInt64Entry, view: BebopView): void {
      view.writeString(record.userID);
      view.writeInt64(record.value);
    },

    decode(buffer: Uint8Array): UserInt64Entry & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = UserInt64Entry.readFrom(view);
      return UserInt64Entry(decoded);
    },

    readFrom(view: BebopView): UserInt64Entry {
      let field0: string;
      field0 = view.readString();
      let field1: bigint;
      field1 = view.readInt64();
      return {
        userID: field0,
        value: field1,
      };
    },
  }
));


export interface Bid {

  readonly tradeRowIndex: number;

  readonly military: number;
}

export const Bid = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: Bid): Bid & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return Bid.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: Bid): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      Bid.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: Bid, view: BebopView): void {
      view.writeByte(record.tradeRowIndex);
      view.writeByte(record.military);
    },

    decode(buffer: Uint8Array): Bid & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = Bid.readFrom(view);
      return Bid(decoded);
    },

    readFrom(view: BebopView): Bid {
      let field0: number;
      field0 = view.readByte();
      let field1: number;
      field1 = view.readByte();
      return {
        tradeRowIndex: field0,
        military: field1,
      };
    },
  }
));


export interface UserBidEntry {

  readonly userID: string;

  readonly bid: Bid;
}

export const UserBidEntry = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: UserBidEntry): UserBidEntry & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return UserBidEntry.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: UserBidEntry): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      UserBidEntry.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: UserBidEntry, view: BebopView): void {
      view.writeString(record.userID);
      Bid.encodeInto(record.bid, view);
    },

    decode(buffer: Uint8Array): UserBidEntry & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = UserBidEntry.readFrom(view);
      return UserBidEntry(decoded);
    },

    readFrom(view: BebopView): UserBidEntry {
      let field0: string;
      field0 = view.readString();
      let field1: Bid;
      field1 = Bid.readFrom(view);
      return {
        userID: field0,
        bid: field1,
      };
    },
  }
));


export interface ResolutionSelection {

  readonly cardIDToGain: string;
}

export const ResolutionSelection = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ResolutionSelection): ResolutionSelection & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return ResolutionSelection.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: ResolutionSelection): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ResolutionSelection.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ResolutionSelection, view: BebopView): void {
      view.writeString(record.cardIDToGain);
    },

    decode(buffer: Uint8Array): ResolutionSelection & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ResolutionSelection.readFrom(view);
      return ResolutionSelection(decoded);
    },

    readFrom(view: BebopView): ResolutionSelection {
      let field0: string;
      field0 = view.readString();
      return {
        cardIDToGain: field0,
      };
    },
  }
));


export interface UserResolvesEntry {

  readonly userID: string;

  readonly selection: ResolutionSelection;
}

export const UserResolvesEntry = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: UserResolvesEntry): UserResolvesEntry & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return UserResolvesEntry.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: UserResolvesEntry): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      UserResolvesEntry.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: UserResolvesEntry, view: BebopView): void {
      view.writeString(record.userID);
      ResolutionSelection.encodeInto(record.selection, view);
    },

    decode(buffer: Uint8Array): UserResolvesEntry & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = UserResolvesEntry.readFrom(view);
      return UserResolvesEntry(decoded);
    },

    readFrom(view: BebopView): UserResolvesEntry {
      let field0: string;
      field0 = view.readString();
      let field1: ResolutionSelection;
      field1 = ResolutionSelection.readFrom(view);
      return {
        userID: field0,
        selection: field1,
      };
    },
  }
));


export interface GameUpdateMessage {

  gameID?: string;

  targetSequenceID?: number;

  sequenceID?: number;

  newEventsMsgpack?: Uint8Array;

  gameStartTimestamp?: bigint;

  gameUpdateTimestamp?: bigint;

  gameEndTimestamp?: bigint;

  hasGameEndTimestamp?: boolean;

  ratingDeltas?: GameRatingDelta[];

  readyByUserID?: UserBoolEntry[];

  totalThinkingMillisByPlayerID?: UserInt64Entry[];

  phaseThinkingMillisByPlayerID?: UserInt64Entry[];

  phaseStartTimestamp?: bigint;

  bidsByPlayerID?: UserBidEntry[];

  resolvesByPlayerID?: UserResolvesEntry[];
}

export const GameUpdateMessage = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: GameUpdateMessage): GameUpdateMessage & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return GameUpdateMessage.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: GameUpdateMessage): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      GameUpdateMessage.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: GameUpdateMessage, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.gameID !== undefined) {
        view.writeByte(1);
        view.writeString(record.gameID);
      }
      if (record.targetSequenceID !== undefined) {
        view.writeByte(2);
        view.writeUint32(record.targetSequenceID);
      }
      if (record.sequenceID !== undefined) {
        view.writeByte(3);
        view.writeUint32(record.sequenceID);
      }
      if (record.newEventsMsgpack !== undefined) {
        view.writeByte(4);
        view.writeBytes(record.newEventsMsgpack);
      }
      if (record.gameStartTimestamp !== undefined) {
        view.writeByte(5);
        view.writeInt64(record.gameStartTimestamp);
      }
      if (record.gameUpdateTimestamp !== undefined) {
        view.writeByte(6);
        view.writeInt64(record.gameUpdateTimestamp);
      }
      if (record.gameEndTimestamp !== undefined) {
        view.writeByte(7);
        view.writeInt64(record.gameEndTimestamp);
      }
      if (record.hasGameEndTimestamp !== undefined) {
        view.writeByte(8);
        view.writeByte(Number(record.hasGameEndTimestamp));
      }
      if (record.ratingDeltas !== undefined) {
        view.writeByte(9);
        {
        const length0 = record.ratingDeltas.length;
        view.writeUint32(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          GameRatingDelta.encodeInto(record.ratingDeltas[i0], view);
        }
      }
      }
      if (record.readyByUserID !== undefined) {
        view.writeByte(10);
        {
        const length0 = record.readyByUserID.length;
        view.writeUint32(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          UserBoolEntry.encodeInto(record.readyByUserID[i0], view);
        }
      }
      }
      if (record.totalThinkingMillisByPlayerID !== undefined) {
        view.writeByte(11);
        {
        const length0 = record.totalThinkingMillisByPlayerID.length;
        view.writeUint32(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          UserInt64Entry.encodeInto(record.totalThinkingMillisByPlayerID[i0], view);
        }
      }
      }
      if (record.phaseThinkingMillisByPlayerID !== undefined) {
        view.writeByte(12);
        {
        const length0 = record.phaseThinkingMillisByPlayerID.length;
        view.writeUint32(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          UserInt64Entry.encodeInto(record.phaseThinkingMillisByPlayerID[i0], view);
        }
      }
      }
      if (record.phaseStartTimestamp !== undefined) {
        view.writeByte(13);
        view.writeInt64(record.phaseStartTimestamp);
      }
      if (record.bidsByPlayerID !== undefined) {
        view.writeByte(14);
        {
        const length0 = record.bidsByPlayerID.length;
        view.writeUint32(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          UserBidEntry.encodeInto(record.bidsByPlayerID[i0], view);
        }
      }
      }
      if (record.resolvesByPlayerID !== undefined) {
        view.writeByte(15);
        {
        const length0 = record.resolvesByPlayerID.length;
        view.writeUint32(length0);
        for (let i0 = 0; i0 < length0; i0++) {
          UserResolvesEntry.encodeInto(record.resolvesByPlayerID[i0], view);
        }
      }
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): GameUpdateMessage & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = GameUpdateMessage.readFrom(view);
      return GameUpdateMessage(decoded);
    },

    readFrom(view: BebopView): GameUpdateMessage {
      const message: GameUpdateMessage = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.gameID = view.readString();
            break;

          case 2:
            message.targetSequenceID = view.readUint32();
            break;

          case 3:
            message.sequenceID = view.readUint32();
            break;

          case 4:
            message.newEventsMsgpack = view.readBytes();
            break;

          case 5:
            message.gameStartTimestamp = view.readInt64();
            break;

          case 6:
            message.gameUpdateTimestamp = view.readInt64();
            break;

          case 7:
            message.gameEndTimestamp = view.readInt64();
            break;

          case 8:
            message.hasGameEndTimestamp = !!view.readByte();
            break;

          case 9:
            {
          const length0 = view.readUint32();
          message.ratingDeltas = [];
          for (let i0 = 0; i0 < length0; i0++) {
            let x0: GameRatingDelta;
            x0 = GameRatingDelta.readFrom(view);
            message.ratingDeltas[i0] = x0;
          }
        }
            break;

          case 10:
            {
          const length0 = view.readUint32();
          message.readyByUserID = [];
          for (let i0 = 0; i0 < length0; i0++) {
            let x0: UserBoolEntry;
            x0 = UserBoolEntry.readFrom(view);
            message.readyByUserID[i0] = x0;
          }
        }
            break;

          case 11:
            {
          const length0 = view.readUint32();
          message.totalThinkingMillisByPlayerID = [];
          for (let i0 = 0; i0 < length0; i0++) {
            let x0: UserInt64Entry;
            x0 = UserInt64Entry.readFrom(view);
            message.totalThinkingMillisByPlayerID[i0] = x0;
          }
        }
            break;

          case 12:
            {
          const length0 = view.readUint32();
          message.phaseThinkingMillisByPlayerID = [];
          for (let i0 = 0; i0 < length0; i0++) {
            let x0: UserInt64Entry;
            x0 = UserInt64Entry.readFrom(view);
            message.phaseThinkingMillisByPlayerID[i0] = x0;
          }
        }
            break;

          case 13:
            message.phaseStartTimestamp = view.readInt64();
            break;

          case 14:
            {
          const length0 = view.readUint32();
          message.bidsByPlayerID = [];
          for (let i0 = 0; i0 < length0; i0++) {
            let x0: UserBidEntry;
            x0 = UserBidEntry.readFrom(view);
            message.bidsByPlayerID[i0] = x0;
          }
        }
            break;

          case 15:
            {
          const length0 = view.readUint32();
          message.resolvesByPlayerID = [];
          for (let i0 = 0; i0 < length0; i0++) {
            let x0: UserResolvesEntry;
            x0 = UserResolvesEntry.readFrom(view);
            message.resolvesByPlayerID[i0] = x0;
          }
        }
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface ObjectUpdateHeader {

  readonly topic: string;

  readonly objectType: ObjectType;

  readonly objectID: string;

  readonly sequenceID: number;
}

export const ObjectUpdateHeader = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ObjectUpdateHeader): ObjectUpdateHeader & BebopRecord => {
    return Object.freeze({
      ...data,
      encode(): Uint8Array {
        return ObjectUpdateHeader.encode(this);
      }
    });
  },
  // Static methods
  {
    encode(record: ObjectUpdateHeader): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ObjectUpdateHeader.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ObjectUpdateHeader, view: BebopView): void {
      view.writeString(record.topic);
      view.writeUint32(record.objectType);
      view.writeString(record.objectID);
      view.writeUint32(record.sequenceID);
    },

    decode(buffer: Uint8Array): ObjectUpdateHeader & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ObjectUpdateHeader.readFrom(view);
      return ObjectUpdateHeader(decoded);
    },

    readFrom(view: BebopView): ObjectUpdateHeader {
      let field0: string;
      field0 = view.readString();
      let field1: ObjectType;
      field1 = view.readUint32();
      let field2: string;
      field2 = view.readString();
      let field3: number;
      field3 = view.readUint32();
      return {
        topic: field0,
        objectType: field1,
        objectID: field2,
        sequenceID: field3,
      };
    },
  }
));


export interface ObjectUpdateMessage {

  header?: ObjectUpdateHeader;

  data?: GameUpdateMessage;
}

export const ObjectUpdateMessage = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ObjectUpdateMessage): ObjectUpdateMessage & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return ObjectUpdateMessage.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: ObjectUpdateMessage): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ObjectUpdateMessage.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ObjectUpdateMessage, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.header !== undefined) {
        view.writeByte(1);
        ObjectUpdateHeader.encodeInto(record.header, view);
      }
      if (record.data !== undefined) {
        view.writeByte(2);
        GameUpdateMessage.encodeInto(record.data, view);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): ObjectUpdateMessage & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ObjectUpdateMessage.readFrom(view);
      return ObjectUpdateMessage(decoded);
    },

    readFrom(view: BebopView): ObjectUpdateMessage {
      const message: ObjectUpdateMessage = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.header = ObjectUpdateHeader.readFrom(view);
            break;

          case 2:
            message.data = GameUpdateMessage.readFrom(view);
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface ChatNotification {

  userID?: string;

  room?: string;

  text?: string;
}

export const ChatNotification = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ChatNotification): ChatNotification & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return ChatNotification.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: ChatNotification): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ChatNotification.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ChatNotification, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.userID !== undefined) {
        view.writeByte(1);
        view.writeString(record.userID);
      }
      if (record.room !== undefined) {
        view.writeByte(2);
        view.writeString(record.room);
      }
      if (record.text !== undefined) {
        view.writeByte(3);
        view.writeString(record.text);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): ChatNotification & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ChatNotification.readFrom(view);
      return ChatNotification(decoded);
    },

    readFrom(view: BebopView): ChatNotification {
      const message: ChatNotification = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.userID = view.readString();
            break;

          case 2:
            message.room = view.readString();
            break;

          case 3:
            message.text = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface LobbyListNotification {

  topic?: string;
}

export const LobbyListNotification = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: LobbyListNotification): LobbyListNotification & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return LobbyListNotification.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: LobbyListNotification): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      LobbyListNotification.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: LobbyListNotification, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.topic !== undefined) {
        view.writeByte(1);
        view.writeString(record.topic);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): LobbyListNotification & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = LobbyListNotification.readFrom(view);
      return LobbyListNotification(decoded);
    },

    readFrom(view: BebopView): LobbyListNotification {
      const message: LobbyListNotification = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.topic = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface AuthSuccess {

  userID?: string;
}

export const AuthSuccess = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: AuthSuccess): AuthSuccess & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return AuthSuccess.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: AuthSuccess): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      AuthSuccess.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: AuthSuccess, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.userID !== undefined) {
        view.writeByte(1);
        view.writeString(record.userID);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): AuthSuccess & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = AuthSuccess.readFrom(view);
      return AuthSuccess(decoded);
    },

    readFrom(view: BebopView): AuthSuccess {
      const message: AuthSuccess = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.userID = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface AuthError {

  errorMessage?: string;
}

export const AuthError = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: AuthError): AuthError & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return AuthError.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: AuthError): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      AuthError.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: AuthError, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.errorMessage !== undefined) {
        view.writeByte(1);
        view.writeString(record.errorMessage);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): AuthError & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = AuthError.readFrom(view);
      return AuthError(decoded);
    },

    readFrom(view: BebopView): AuthError {
      const message: AuthError = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.errorMessage = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface ToastNotification {

  id?: string;

  text?: string;
}

export const ToastNotification = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ToastNotification): ToastNotification & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return ToastNotification.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: ToastNotification): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ToastNotification.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ToastNotification, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.id !== undefined) {
        view.writeByte(1);
        view.writeString(record.id);
      }
      if (record.text !== undefined) {
        view.writeByte(2);
        view.writeString(record.text);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): ToastNotification & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ToastNotification.readFrom(view);
      return ToastNotification(decoded);
    },

    readFrom(view: BebopView): ToastNotification {
      const message: ToastNotification = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.id = view.readString();
            break;

          case 2:
            message.text = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export type ServerMessage = { tag: 1, value: ObjectUpdateMessage } | { tag: 2, value: ChatNotification } | { tag: 3, value: LobbyListNotification } | { tag: 4, value: AuthSuccess } | { tag: 5, value: AuthError } | { tag: 6, value: ToastNotification };

export const ServerMessage = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ServerMessage): ServerMessage & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return ServerMessage.encode(this);
      }
    };
  },
  // Static methods
  {
    fromObjectUpdateMessage(value: ObjectUpdateMessage): ServerMessage & BebopRecord {
      return ServerMessage({ tag: 1, value });
    },

    fromChatNotification(value: ChatNotification): ServerMessage & BebopRecord {
      return ServerMessage({ tag: 2, value });
    },

    fromLobbyListNotification(value: LobbyListNotification): ServerMessage & BebopRecord {
      return ServerMessage({ tag: 3, value });
    },

    fromAuthSuccess(value: AuthSuccess): ServerMessage & BebopRecord {
      return ServerMessage({ tag: 4, value });
    },

    fromAuthError(value: AuthError): ServerMessage & BebopRecord {
      return ServerMessage({ tag: 5, value });
    },

    fromToastNotification(value: ToastNotification): ServerMessage & BebopRecord {
      return ServerMessage({ tag: 6, value });
    },

    encode(record: ServerMessage): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ServerMessage.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ServerMessage, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length + 1;
      view.writeByte(record.tag);
      switch (record.tag) {
        case 1:
          ObjectUpdateMessage.encodeInto(record.value, view);
          break;
        case 2:
          ChatNotification.encodeInto(record.value, view);
          break;
        case 3:
          LobbyListNotification.encodeInto(record.value, view);
          break;
        case 4:
          AuthSuccess.encodeInto(record.value, view);
          break;
        case 5:
          AuthError.encodeInto(record.value, view);
          break;
        case 6:
          ToastNotification.encodeInto(record.value, view);
          break;
      }
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): ServerMessage & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ServerMessage.readFrom(view);
      return ServerMessage(decoded);
    },

    readFrom(view: BebopView): ServerMessage {
      const length = view.readMessageLength();
      const end = view.index + 1 + length;
      const tag = view.readByte();
      switch (tag) {
        case 1:
          return { tag: 1, value: ObjectUpdateMessage.readFrom(view) };
        case 2:
          return { tag: 2, value: ChatNotification.readFrom(view) };
        case 3:
          return { tag: 3, value: LobbyListNotification.readFrom(view) };
        case 4:
          return { tag: 4, value: AuthSuccess.readFrom(view) };
        case 5:
          return { tag: 5, value: AuthError.readFrom(view) };
        case 6:
          return { tag: 6, value: ToastNotification.readFrom(view) };
        default:
          view.index = end;
          throw new BebopRuntimeError(`Unknown union discriminator: ${tag}`);
      }
    },
  }
));


export interface Subscribe {

  topic?: string;
}

export const Subscribe = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: Subscribe): Subscribe & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return Subscribe.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: Subscribe): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      Subscribe.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: Subscribe, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.topic !== undefined) {
        view.writeByte(1);
        view.writeString(record.topic);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): Subscribe & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = Subscribe.readFrom(view);
      return Subscribe(decoded);
    },

    readFrom(view: BebopView): Subscribe {
      const message: Subscribe = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.topic = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface Unsubscribe {

  topic?: string;
}

export const Unsubscribe = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: Unsubscribe): Unsubscribe & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return Unsubscribe.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: Unsubscribe): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      Unsubscribe.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: Unsubscribe, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.topic !== undefined) {
        view.writeByte(1);
        view.writeString(record.topic);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): Unsubscribe & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = Unsubscribe.readFrom(view);
      return Unsubscribe(decoded);
    },

    readFrom(view: BebopView): Unsubscribe {
      const message: Unsubscribe = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.topic = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface Chat {

  room?: string;

  text?: string;
}

export const Chat = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: Chat): Chat & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return Chat.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: Chat): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      Chat.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: Chat, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.room !== undefined) {
        view.writeByte(1);
        view.writeString(record.room);
      }
      if (record.text !== undefined) {
        view.writeByte(2);
        view.writeString(record.text);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): Chat & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = Chat.readFrom(view);
      return Chat(decoded);
    },

    readFrom(view: BebopView): Chat {
      const message: Chat = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.room = view.readString();
            break;

          case 2:
            message.text = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface AuthUser {

  jwt?: string;
}

export const AuthUser = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: AuthUser): AuthUser & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return AuthUser.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: AuthUser): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      AuthUser.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: AuthUser, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      if (record.jwt !== undefined) {
        view.writeByte(1);
        view.writeString(record.jwt);
      }
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): AuthUser & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = AuthUser.readFrom(view);
      return AuthUser(decoded);
    },

    readFrom(view: BebopView): AuthUser {
      const message: AuthUser = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          case 1:
            message.jwt = view.readString();
            break;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export interface AuthAnonymous {
}

export const AuthAnonymous = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: AuthAnonymous): AuthAnonymous & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return AuthAnonymous.encode(this);
      }
    };
  },
  // Static methods
  {
    encode(record: AuthAnonymous): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      AuthAnonymous.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: AuthAnonymous, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length;
      view.writeByte(0);
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): AuthAnonymous & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = AuthAnonymous.readFrom(view);
      return AuthAnonymous(decoded);
    },

    readFrom(view: BebopView): AuthAnonymous {
      const message: AuthAnonymous = {};
      const length = view.readMessageLength();
      const end = view.index + length;
      while (true) {
        switch (view.readByte()) {
          case 0:
            return message;

          default:
            view.index = end;
            return message;
        }
      }
    },
  }
));


export type ClientMessage = { tag: 1, value: Subscribe } | { tag: 2, value: Unsubscribe } | { tag: 3, value: Chat } | { tag: 4, value: AuthUser } | { tag: 5, value: AuthAnonymous };

export const ClientMessage = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(
  // Factory function
  (data: ClientMessage): ClientMessage & BebopRecord => {
    return {
      ...data,
      encode(): Uint8Array {
        return ClientMessage.encode(this);
      }
    };
  },
  // Static methods
  {
    fromSubscribe(value: Subscribe): ClientMessage & BebopRecord {
      return ClientMessage({ tag: 1, value });
    },

    fromUnsubscribe(value: Unsubscribe): ClientMessage & BebopRecord {
      return ClientMessage({ tag: 2, value });
    },

    fromChat(value: Chat): ClientMessage & BebopRecord {
      return ClientMessage({ tag: 3, value });
    },

    fromAuthUser(value: AuthUser): ClientMessage & BebopRecord {
      return ClientMessage({ tag: 4, value });
    },

    fromAuthAnonymous(value: AuthAnonymous): ClientMessage & BebopRecord {
      return ClientMessage({ tag: 5, value });
    },

    encode(record: ClientMessage): Uint8Array {
      const view = BebopView.getInstance();
      view.startWriting();
      ClientMessage.encodeInto(record, view);
      return view.toArray();
    },

    encodeInto(record: ClientMessage, view: BebopView): void {
      const pos = view.reserveMessageLength();
      const start = view.length + 1;
      view.writeByte(record.tag);
      switch (record.tag) {
        case 1:
          Subscribe.encodeInto(record.value, view);
          break;
        case 2:
          Unsubscribe.encodeInto(record.value, view);
          break;
        case 3:
          Chat.encodeInto(record.value, view);
          break;
        case 4:
          AuthUser.encodeInto(record.value, view);
          break;
        case 5:
          AuthAnonymous.encodeInto(record.value, view);
          break;
      }
      const end = view.length;
      view.fillMessageLength(pos, end - start);
    },

    decode(buffer: Uint8Array): ClientMessage & BebopRecord {
      const view = BebopView.getInstance();
      view.startReading(buffer);
      const decoded = ClientMessage.readFrom(view);
      return ClientMessage(decoded);
    },

    readFrom(view: BebopView): ClientMessage {
      const length = view.readMessageLength();
      const end = view.index + 1 + length;
      const tag = view.readByte();
      switch (tag) {
        case 1:
          return { tag: 1, value: Subscribe.readFrom(view) };
        case 2:
          return { tag: 2, value: Unsubscribe.readFrom(view) };
        case 3:
          return { tag: 3, value: Chat.readFrom(view) };
        case 4:
          return { tag: 4, value: AuthUser.readFrom(view) };
        case 5:
          return { tag: 5, value: AuthAnonymous.readFrom(view) };
        default:
          view.index = end;
          throw new BebopRuntimeError(`Unknown union discriminator: ${tag}`);
      }
    },
  }
));

